'use client';

interface EducationItem {
  id: string;
  institution: string;
  degree: string;
  period: string;
  location: string;
  score: string;
  accentColor: string;
  highlights: string[];
}

const EDUCATION: EducationItem[] = [
  {
    id: 'EDU-001',
    institution: 'Vishwakarma Institute of Technology (VIT)',
    degree: 'Bachelor of Engineering (Computer Engineering)',
    period: '2021 - 2025',
    location: 'Pune, Maharashtra',
    score: 'CGPA: 8.8 / 10',
    accentColor: 'var(--cyber-cyan)',
    highlights: [
      'Maintained strong academic performance with consistent distinction in core Computer Science subjects.',
      'Actively participated in technical workshops, hackathons, and coding challenges.',
      'Strong foundation in Data Structures, Algorithms, DBMS, Operating Systems, and OOP.',
      'Led end-to-end development of multiple academic and self-driven technical projects.'
    ],
  },
];

export default function EducationSection() {
  return (
    <section
      id="education"
      className="relative py-24 px-6 md:px-12 overflow-hidden"
      style={{ background: 'var(--cyber-black)' }}
      aria-label="Education section"
    >
      <div
        className="absolute inset-0 pointer-events-none"
        style={{ background: 'linear-gradient(225deg, rgba(0,212,255,0.04) 0%, transparent 45%)' }}
      />

      <div className="relative z-10 max-w-7xl mx-auto">
        <div className="mb-16">
          <p className="font-mono text-xs mb-3" style={{ color: 'var(--cyber-yellow)', letterSpacing: '0.3em' }}>
            // MODULE:04 
          </p>
          <h2 className="font-mono font-black text-4xl md:text-6xl" style={{ color: '#FFFFFF', letterSpacing: '-0.02em' }}>
            EDU<span className="text-glow-cyan">_ARCHIVE</span>
          </h2>
          <p className="font-mono text-sm mt-4" style={{ color: 'rgba(200,216,232,0.5)' }}>
            FORMAL_TRAINING: {EDUCATION.length} RECORD // VERIFIED
          </p>
        </div>

        <div className="grid gap-6">
          {EDUCATION.map((edu) => (
            <div
              key={edu.id}
              className="cyber-panel p-6 md:p-8"
              style={{ border: `1px solid ${edu.accentColor}22` }}
            >
              <div className="flex flex-col md:flex-row md:items-start justify-between gap-5 mb-6">
                <div>
                  <div className="flex items-center gap-3 mb-2">
                    <span
                      className="font-mono text-[9px] px-2 py-0.5"
                      style={{
                        background: `${edu.accentColor}12`,
                        border: `1px solid ${edu.accentColor}35`,
                        color: edu.accentColor,
                        letterSpacing: '0.15em',
                      }}
                    >
                      {edu.id}
                    </span>
                  </div>
                  <h3 className="font-mono font-black text-lg md:text-2xl mb-1" style={{ color: '#FFFFFF' }}>
                    {edu.degree}
                  </h3>
                  <p className="font-mono text-sm font-bold" style={{ color: edu.accentColor }}>
                    {edu.institution}
                  </p>
                </div>

                <div className="text-left md:text-right shrink-0">
                  <div className="font-mono text-xs font-bold mb-1" style={{ color: 'rgba(200,216,232,0.75)' }}>
                    {edu.period}
                  </div>
                  <div className="font-mono text-[10px] mb-1" style={{ color: 'rgba(200,216,232,0.45)', letterSpacing: '0.1em' }}>
                    {edu.location}
                  </div>
                  <div className="font-mono text-[10px]" style={{ color: 'var(--cyber-green)', letterSpacing: '0.12em' }}>
                    {edu.score}
                  </div>
                </div>
              </div>

              <div className="space-y-2" style={{ borderTop: `1px solid ${edu.accentColor}15`, paddingTop: '16px' }}>
                {edu.highlights.map((h, i) => (
                  <div key={i} className="flex items-start gap-3">
                    <span className="font-mono text-xs mt-0.5 shrink-0" style={{ color: edu.accentColor }}>*</span>
                    <p className="font-mono text-xs leading-relaxed" style={{ color: 'rgba(200,216,232,0.68)' }}>
                      {h}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
